export default "__VITE_ASSET__1apHBXPu__"